import { MultiSelect } from 'react-multi-select-component';
import { ISelectOption } from 'src/lib';
import '../../../filters/components/filters.scss';

interface IMultiSelectControlField2Props {
  label: string;
  value: ISelectOption[];
  options: ISelectOption[];
  isDisabled: boolean;
  handleChange: (value: ISelectOption[]) => void;
  // eslint-disable-next-line react/require-default-props
  isMultiSelect?: boolean;
}

export default function SelectComponent({
  handleChange,
  options,
  isDisabled,
  label,
  value = [],
  isMultiSelect = false
}: IMultiSelectControlField2Props) {
  return (
    <div
      className={`filter-div ${isDisabled ? 'disabled-filter-div' : ''}`}
      style={{ width: '100%' }}
    >
      <div>{label}</div>
      <MultiSelect
        options={options.slice().sort((a, b) => (a.label > b.label ? 1 : -1))}
        value={value}
        hasSelectAll={isMultiSelect}
        // passing filter name, value and it's position/index
        onChange={handleChange}
        labelledBy='Select'
        className='multi-select-div'
        overrideStrings={{
          allItemsAreSelected: 'All'
        }}
        disabled={isDisabled}
      />
    </div>
  );
}
